import { render, staticRenderFns } from "./zl-step.vue?vue&type=template&id=0896b1f8&scoped=true&"
import script from "./zl-step.vue?vue&type=script&lang=js&"
export * from "./zl-step.vue?vue&type=script&lang=js&"
import style0 from "./zl-step.vue?vue&type=style&index=0&id=0896b1f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0896b1f8",
  null
  
)

export default component.exports